import Large from './Large';
import Regular from './Regular';
import Small from './Small';
import Micro from './Micro';
import Action from './Action';

export default {
  Large,
  Regular,
  Small,
  Micro,
  Action,
};

export const Text = Regular;
export const TextLarge = Large;
export const TextRegular = Regular;
export const TextSmall = Small;
export const TextMicro = Micro;
